import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_DE.json';
import exercises from './PILATES_EXERCISES_DE.json';
import recipes from './PILATES_RECIPES_DE.json';

export const PILATES_DATA_DE: ServiceData = {
  articles,
  exercises,
  recipes,
};
